import IApiViolation from '../../../shared/api/model/IApiViolation';

export interface IPortMonitorViolations {
    fields: Record<string, string>,
    common?: string,
}

const PROPERTY_PATH_TO_FIELD: Record<string, string> = {
    ip: 'ip',
    port: 'port',
    name: 'name',
    timeout: 'timeout',
    check_interval: 'check_interval',
    locations: 'locations',
    threshold: 'threshold',
    'threshold.threshold': 'threshold',
    telegram_chats: 'telegram_chats',
    max_chats: 'max_chats',
    additional_emails: 'additional_emails',
    tags: 'tags',
};

export const mapPortMonitorViolations = (violations?: IApiViolation[]): IPortMonitorViolations => {
    const fields: Record<string, string> = {};
    const common: string[] = [];

    (violations ?? []).forEach(({propertyPath, message}) => {
        const field = propertyPath ? PROPERTY_PATH_TO_FIELD[propertyPath] : undefined;

        if (!field) {
            common.push(message);
            return;
        }

        if (!fields[field]) {
            fields[field] = message;
        }
    });

    return common.length > 0 ? {fields, common: common.join('\n')} : {fields};
};
